import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  drill_down(event) {
    const workNo = event.target.dataset.workHoursAuditRateTableWorkNo;
    if (!workNo) {
      return;
    }
    const orgCode = event.target.dataset.workHoursAuditRateTableOrgCode;
    const monthName = $('#month_name').val();
    const sentData = {
      org_code: orgCode,
      work_no: workNo,
      month_name: monthName
    };

    $.ajax('/report/work_hours_audit_rate/detail_table_drill_down', {
      data: sentData,
      dataType: 'script'
    });
  }
}
